var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "card mx-auto mt-0 mt-lg-4 col-6 col-sm-3 col-lg-12" },
    [
      _c(
        "div",
        { staticClass: "card-body p-0 py-3 p-lg-3" },
        [
          _c("h3", [_vm._v(_vm._s(_vm.T.wordsQuality))]),
          _vm._l(_vm.qualityValues, function(quality) {
            return _c("div", { key: quality.id, staticClass: "form-check" }, [
              _c("label", { staticClass: "form-check-label" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.currentQuality,
                      expression: "currentQuality"
                    }
                  ],
                  staticClass: "form-check-input",
                  attrs: { type: "radio", name: "quality" },
                  domProps: {
                    value: quality.id,
                    checked: _vm._q(_vm.currentQuality, quality.id)
                  },
                  on: {
                    click: function($event) {
                      return _vm.$emit("change-quality", quality.id)
                    },
                    change: function($event) {
                      _vm.currentQuality = quality.id
                    }
                  }
                }),
                _vm._v(_vm._s(quality.name) + " ")
              ])
            ])
          })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }